var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSilverRank5(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#silver_rank_5_svg__clip0_1947_6789)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "silver_rank_5_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.865.11H0V197.89h200.865V.111z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#silver_rank_5_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.334 38.327c-5.344-5.596-14.62-4.141-18.037 2.792-8.93 18.1-6.153 40.587 8.615 56.053 18.43 19.298 48.732 20.542 68.68 3.201L37.333 38.327z",
    fill: "#DCDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.322 75.59C6.903 73.353-.439 79.182.024 86.892c1.201 20.139 14.761 38.321 35.265 44.5 25.585 7.71 52.553-6.121 61.308-31.02L14.322 75.59z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 121.656c-7.507 1.922-10.76 10.7-6.358 17.055 11.497 16.605 32.546 25.156 53.291 19.853 25.89-6.618 41.771-32.376 36.315-58.191l-42.55 10.875-40.704 10.402.006.006z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 38.327c5.344-5.596 14.621-4.141 18.037 2.792 8.931 18.1 6.153 40.587-8.614 56.053-18.43 19.298-48.732 20.542-68.68 3.201l59.257-62.046z",
    fill: "#DCDBDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.543 75.59c7.419-2.237 14.762 3.592 14.305 11.308-1.202 20.139-14.762 38.321-35.266 44.5-25.585 7.71-52.553-6.121-61.308-31.02l82.269-24.788z",
    fill: "#D7D5D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.522 121.656c7.507 1.922 10.759 10.7 6.358 17.055-11.497 16.605-32.547 25.156-53.291 19.853-25.89-6.618-41.77-32.376-36.315-58.191l42.55 10.875 40.704 10.402-.006.006z",
    fill: "#D2D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.792.11h108.224c6.47 0 11.72 5.234 11.72 11.682V132.27c0 36.212-29.499 65.614-65.832 65.614-36.332 0-65.832-29.402-65.832-65.614V11.792c0-6.448 5.25-11.681 11.72-11.681z",
    fill: "#CDCBCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.195 67.46h75.413c4.506 0 8.169 3.645 8.169 8.142v49.243c0 25.238-20.557 45.721-45.873 45.721-25.321 0-45.872-20.489-45.872-45.721V75.602c0-4.492 3.657-8.142 8.169-8.142h-.006z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.608 69.796c3.211 0 5.825 2.605 5.825 5.806v49.243c0 23.923-19.526 43.385-43.529 43.385-24.002 0-43.528-19.462-43.528-43.385V75.602c0-3.2 2.613-5.806 5.825-5.806h75.413m0-2.336h-75.42c-4.511 0-8.168 3.645-8.168 8.142v49.243c0 25.249 20.54 45.721 45.872 45.721 25.334 0 45.873-20.472 45.873-45.721V75.602c0-4.497-3.657-8.142-8.169-8.142h.012z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.016.11h-44.982L35.072 74.826V126.3l125.3-124.892a11.693 11.693 0 00-5.356-1.296zM95.712 112.077l71.024-70.79V12.12L81.079 97.493l14.633 14.584z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.966 22.025L82 28.263c.222.69.867 1.156 1.6 1.156h6.58c1.63 0 2.303 2.074.985 3.026L85.844 36.3a1.674 1.674 0 00-.61 1.869l2.034 6.238c.504 1.542-1.266 2.827-2.584 1.869l-5.321-3.855a1.684 1.684 0 00-1.975 0l-5.321 3.855c-1.318.952-3.088-.327-2.584-1.87l2.033-6.237a1.674 1.674 0 00-.61-1.87l-5.32-3.854c-1.319-.952-.639-3.026.984-3.026h6.581c.727 0 1.371-.467 1.6-1.156l2.033-6.238c.504-1.542 2.69-1.542 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.966 22.025L82 28.263c.222.69.867 1.156 1.6 1.156h6.58c1.63 0 2.303 2.074.985 3.026L85.844 36.3a1.674 1.674 0 00-.61 1.869l2.034 6.238c.504 1.542-1.266 2.827-2.584 1.869l-5.321-3.855a1.684 1.684 0 00-1.975 0l-5.321 3.855c-1.318.952-3.088-.327-2.584-1.87l2.033-6.237a1.674 1.674 0 00-.61-1.87l-5.32-3.854c-1.319-.952-.639-3.026.984-3.026h6.581c.727 0 1.371-.467 1.6-1.156l2.033-6.238c.504-1.542 2.69-1.542 3.194 0h-.012z",
    fill: "#FEE066"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.686 22.025l2.034 6.238c.222.69.867 1.156 1.599 1.156h6.581c1.629 0 2.303 2.074.985 3.026l-5.321 3.855a1.676 1.676 0 00-.61 1.869l2.034 6.238c.504 1.542-1.266 2.827-2.584 1.869l-5.321-3.855a1.685 1.685 0 00-1.975 0l-5.321 3.855c-1.319.952-3.088-.327-2.584-1.87l2.033-6.237a1.674 1.674 0 00-.609-1.87l-5.321-3.854c-1.319-.952-.639-3.026.984-3.026h6.581c.727 0 1.371-.467 1.6-1.156l2.033-6.238c.504-1.542 2.69-1.542 3.194 0h-.012z",
    stroke: "#000",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.686 22.025l2.034 6.238c.222.69.867 1.156 1.599 1.156h6.581c1.629 0 2.303 2.074.985 3.026l-5.321 3.855a1.676 1.676 0 00-.61 1.869l2.034 6.238c.504 1.542-1.266 2.827-2.584 1.869l-5.321-3.855a1.685 1.685 0 00-1.975 0l-5.321 3.855c-1.319.952-3.088-.327-2.584-1.87l2.033-6.237a1.674 1.674 0 00-.609-1.87l-5.321-3.854c-1.319-.952-.639-3.026.984-3.026h6.581c.727 0 1.371-.467 1.6-1.156l2.033-6.238c.504-1.542 2.69-1.542 3.194 0h-.012z",
    fill: "#FEE066"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "silver_rank_5_svg__clip0_1947_6789"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h201v198H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRank5);
export default ForwardRef;